import { useCallback, useEffect, useMemo } from 'react';

import { GOOGLE_LOGIN_REDIRECT_URI } from 'config/constants';
import { isEmpty, join } from 'lodash';
import { useGoogleAuthToken } from 'sdk';

import { useDialog } from 'utils/hooks';
import { openGoogleLoginPage } from 'utils/integrations/google';
import { useGoogleClassroomLastSync } from 'utils/integrations/googleClassroom';

export const useNewSchoolYearDialog = () => {
  const { data: googleAuthToken } = useGoogleAuthToken();
  const { lastSync: lastGoogleSync } = useGoogleClassroomLastSync();

  const {
    isOpened: isUpdateGoogleClassroomRostersDialogOpened,
    openDialog: openUpdateGoogleClassroomRostersDialog,
    closeDialog: closeUpdateGoogleClassroomRostersDialog
  } = useDialog();

  const shouldOpenUpdateGoogleClassroomRostersDialog = useMemo(
    () => !isEmpty(lastGoogleSync) && googleAuthToken === '',
    [lastGoogleSync, googleAuthToken]
  );

  const goToGoogleAuthScreen = useCallback(() => {
    const redirectUri = GOOGLE_LOGIN_REDIRECT_URI;

    const scope = join(
      [
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/userinfo.profile',
        'https://www.googleapis.com/auth/classroom.profile.emails',
        'https://www.googleapis.com/auth/classroom.courses.readonly',
        'https://www.googleapis.com/auth/classroom.rosters.readonly'
      ],
      ' '
    );

    const state = { override_auth_token: true };
    const prompt = 'consent';

    openGoogleLoginPage(redirectUri, scope, state, prompt);
  }, []);

  useEffect(() => {
    if (shouldOpenUpdateGoogleClassroomRostersDialog) {
      openUpdateGoogleClassroomRostersDialog();
    }
  }, [
    shouldOpenUpdateGoogleClassroomRostersDialog,
    openUpdateGoogleClassroomRostersDialog
  ]);

  return {
    isUpdateGoogleClassroomRostersDialogOpened,
    closeUpdateGoogleClassroomRostersDialog,
    goToGoogleAuthScreen
  };
};
